// src/pages/RiskMapDashboard.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // O Link já está sendo usado
import api from '../services/api';
import { 
    Box, 
    Typography, 
    Grid, 
    Paper, 
    CircularProgress, 
    Container,
    Button // <<< Adicione a importação do Button
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'; // <<< Adicione a importação do ícone

const RiskMapDashboard = () => {
  const [canvases, setCanvases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCanvases = async () => {
      try {
        setLoading(true);
        const response = await api.get('/models');
        setCanvases(response.data);
      } catch (err) {
        setError('Não foi possível carregar os modelos de negócio.');
        console.error("API Error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCanvases();
  }, []);

  if (loading) {
    return <Box display="flex" justifyContent="center" p={4}><CircularProgress /></Box>;
  }

  if (error) {
    return <Typography color="error" sx={{ p: 4 }}>Erro: {error}</Typography>;
  }

  return (
    <Container maxWidth="xl">
        {/* --- BOTÃO DE VOLTAR ADICIONADO AQUI --- */}
        <Button 
            component={Link} 
            to="/" 
            startIcon={<ArrowBackIcon />} 
            sx={{ mb: 2 }}
        >
            Voltar para a Página Inicial
        </Button>

        <Box sx={{ mb: 4, borderBottom: '1px solid #eee', pb: 3 }}>
            <Typography variant="h4" component="h1" sx={{ color: '#333', fontWeight: 'bold' }}>
                Mapa de Riscos do Modelo de Negócio
            </Typography>
            <Typography sx={{ color: '#666', mt: 1 }}>
                Selecione um Modelo de Negócio abaixo para visualizar e adicionar os riscos associados.
            </Typography>
        </Box>

        <Box>
            <Typography variant="h5" component="h2" sx={{ mb: 3, fontWeight: 'bold' }}>
                Modelos Disponíveis
            </Typography>
            {canvases.length === 0 ? (
                <Typography>
                    Nenhum modelo de negócio encontrado. Crie um na seção "Canvas Business Model" primeiro.
                </Typography>
            ) : (
                <Grid container spacing={3}>
                    {canvases.map((canvas) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={canvas.id} sx={{ display: 'flex' }}>
                            <Paper 
                                component={Link} 
                                to={`/riskmap/${canvas.id}`}
                                elevation={2}
                                sx={{ 
                                    p: 2.5, 
                                    textDecoration: 'none', 
                                    color: 'inherit',
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    transition: 'transform 0.3s, box-shadow 0.3s',
                                    '&:hover': { 
                                        transform: 'translateY(-5px)', 
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)' 
                                    }
                                }}
                            >
                                <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 1, flexGrow: 1 }}>
                                    {canvas.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Atualizado em: {new Date(canvas.updatedAt).toLocaleDateString()}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    </Container>
  );
};

export default RiskMapDashboard;